import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=8966%3A20834
 *
 * @param {SvgIconProps} props - svg props
 */
export const TooltipButtonIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0 12C0 5.37258 5.37258 0 12 0V0C18.6274 0 24 5.37258 24 12V12C24 18.6274 18.6274 24 12 24V24C5.37258 24 0 18.6274 0 12V12Z' fill={color}/>
            <path fillRule='evenodd' clipRule='evenodd' d='M13.5 7.5C13.5 8.32843 12.8284 9 12 9C11.1716 9 10.5 8.32843 10.5 7.5C10.5 6.67157 11.1716 6 12 6C12.8284 6 13.5 6.67157 13.5 7.5ZM13.5 15.9783C13.5 16.8187 12.8284 17.5 12 17.5C11.1716 17.5 10.5 16.8187 10.5 15.9783V12.0217C10.5 11.1813 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1813 13.5 12.0217V15.9783Z' fill='white'/>
        </SvgIcon>
    )
}

export default TooltipButtonIcon
